var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFileTransferLine = function SvgFileTransferLine(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M14.7 4.8h-9v14.4h12.6V8.4h-3.6zM3.9 3.893C3.9 3.4 4.302 3 4.8 3h10.8l4.5 4.5v12.594a.9.9 0 0 1-.894.906H4.794a.9.9 0 0 1-.894-.893zM12 11.1V8.4l3.6 3.6-3.6 3.6v-2.7H8.4v-1.8z"
  })));
};
export default SvgFileTransferLine;